var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.template,{ref:"component",tag:"component",attrs:{"steps":_vm.chatSteps,"userData":_vm.userData},on:{"nextStep":_vm.nextStep}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }